import { TFunction } from 'react-i18next';
import { SeoRobotsContainer, SeoFiltersContainer } from '@/modules/Seo/containers';
import { RedirectsListContainer } from '@/modules/Redirects';
import { MetaTagsListContainer } from '@/modules/MetaTags';

export enum SeoTabs {
  META_TAG_TEMPLATES = 'meta_tag_templates',
  ROBOTS = 'robots',
  REDIRECTS = 'redirects',
  FILTERS = 'filters',
}

export const getSeoTabsConfig = (t: TFunction) => [
  {
    label: t('seo_meta_tag_templates_tab_title'),
    key: SeoTabs.META_TAG_TEMPLATES,
    content: <MetaTagsListContainer />,
  },
  {
    label: t('seo_robots_tab_title'),
    key: SeoTabs.ROBOTS,
    content: <SeoRobotsContainer />,
  },
  {
    label: t('seo_redirects_tab_title'),
    key: SeoTabs.REDIRECTS,
    content: <RedirectsListContainer />,
  },
  {
    label: t('seo_filters_tab_title'),
    key: SeoTabs.FILTERS,
    content: <SeoFiltersContainer />,
  },
];
